module.exports = __webpack_public_path__ + "img/Path.68b3fbd5.svg";